/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_ReservationInputs */

const cs_enum_reservation = /** @type {(inputs: Enum_ReservationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rezervace`)
};

const en_enum_reservation = /** @type {(inputs: Enum_ReservationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reservation`)
};

/**
* | output |
* | --- |
* | "Reservation" |
*
* @param {Enum_ReservationInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_reservation = /** @type {((inputs?: Enum_ReservationInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_ReservationInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_reservation(inputs)
	return cs_enum_reservation(inputs)
});